import * as Yup from "yup";

export const validationSchemaPullAPIs = Yup.object({
  web_services_pull_api_select_version_of_pull_api_you_would_like_to_opt_from_i2c: Yup.string()
    .optional() ,
  web_services_pull_api_do_you_have_an_in_house_development_team: Yup.string()
    .optional(),
  web_services_pull_api_confirm_if_third_party_vendor_is_pci_compliant: Yup.string().when(
    "web_services_pull_api_do_you_have_an_in_house_development_team",
    {
      is: (value) => value === "no",
      then: () => Yup.string()
        .optional() ,
      otherwise: () => Yup.string().optional(),
    }
  ),
});
export const validationSchemaPushAPIs = Yup.object().shape({
  web_services_push_api_would_you_like_i2c_push_notification_to_send_notification_to_your_preferred_channels: Yup.string().optional(),
  web_services_push_api_please_confirm_channel_to_send_push_notification: Yup.string().when(
    "web_services_push_api_would_you_like_i2c_push_notification_to_send_notification_to_your_preferred_channels",
    {
      is: "yes",
      then: () =>Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
  web_services_push_api_please_confirm_channel_to_send_push_notification_other: Yup.string().when(
    "web_services_push_api_please_confirm_channel_to_send_push_notification",
    {
      is: "other",
      then: () => Yup.string().optional(),
      otherwise: () => Yup.string().optional(),
    }
  ),
});